import React, {  FunctionComponent } from "react";
import { StyledModal, Backdrop } from "./styled.components";
import { Fade } from "@mui/material";
import { Box } from "@mui/material";

type ModalDialogProps = {
  open: boolean;
  children: any;
  modalSize?: string;
  styles?: any;
  background: string;
};

const ModalDialog: FunctionComponent<ModalDialogProps> = ({
  open,
  children,
  modalSize,
  styles,
  background,
}: any) => {
  const selectModalSize = () => {
    let size = 700;
    switch (modalSize) {
      case "sm":
        size = 400;
        break;
      case "md":
        size = 700;
        break;
      case "lg":
        size = 900;
        break;
      case "xl":
        size = 1200;
        break;
    }
    return size;
  };

  const styled = () => {
    const style = {
      width: selectModalSize(),
      bgcolor: background,
      p: 0,
    };
    return { ...style, ...styles };
  };

  return (
    <>
      <StyledModal open={open} BackdropComponent={Backdrop}>
        <Fade in={true} timeout={500}>
          <Box sx={styled()}>{children}</Box>
        </Fade>
      </StyledModal>
    </>
  );
};

export default ModalDialog;
